import { Component, ElementRef, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '@reusable/services/auth/auth.service';
import * as globals from '@reusable/services/globals';
import { ProfileCustomerService } from '../../services/profile.customer.service';
import { SharedCustomerService } from '../../services/shared.customer.service';

@Component({
  selector: 'app-profile-widget',
  standalone: false,
  templateUrl: './profile-widget.component.html',
  styleUrls: ['./profile-widget.component.scss'],
  host: {
    '(document:click)': 'onClick($event)'
  }

})
export class ProfileWidgetComponent implements OnInit {
  profiledata: any;
  mycarsflag: boolean = false;
  isAuthenticated;
  appURL: string;
  clickHandler: any;
  toggleMenuFlag = false;
  clicedOut: boolean;
  constructor(
    public router: Router,
    public auth: AuthService,
    private pcs: ProfileCustomerService,
    private sharedService: SharedCustomerService,
    private _eref: ElementRef
  ) {}

  ngOnInit() {
    this.appURL = globals.appURL;
    this.isAuthenticated = this.auth.isLoggedIn();
    if (this.isAuthenticated) {
      this.profileView();
      this.sharedService.watchStorage().subscribe((data: string) => {
        if (data) {
          this.profileView();
        }
      });
    }
  }
  onClick(event) {
    if (!this._eref.nativeElement.contains(event.target)) {
      this.closeMenu();
    }
  }

  logOut() {
    this.auth.logout();
  }

  openMyCars() {
    this.mycarsflag = true;
    setTimeout(() => (this.mycarsflag = false), 1000);
  }

  toggleMenu() {
    this.toggleMenuFlag = !this.toggleMenuFlag;
  }

  closeMenu() {
    this.toggleMenuFlag = false;
  }

  profileView() {
    this.pcs.userProfile().subscribe((userData: any) => {
      if (userData.case === 1) {
        this.profiledata = userData.user;
      }
    });
  }
}